import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {Text1, Title1} from "../../../../styles/business-components";
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";
import Image from '../../../../assets/images/business/b_m_cnt8_img1.png'

import * as S from './styles'

export const Content8 = observer(() => {

  const { businessStore } = useStores()

  return (
    <S.CustomContainer>
        <S.Title>Самостоятельное размещение</S.Title>
        <S.Content>
            <S.TextBlock>
                <S.Text>
                    От 500 сотрудников. При самостоятельном хостинге все полностью в ваших руках.
                    TeleGuard устанавливается на ваших серверах. Подходит для внутренних коммуникаций в
                    органах власти, компаниях и организациях с высокими требованиями к защите и сохранности данных,
                    а также к защите от рисков в случае киберпреступлений.
                </S.Text>
                <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}>
                    <Uppercase>Запросить консультацию</Uppercase>
                </Button>
            </S.TextBlock>
            <div>
                <S.Image src={Image}/>
            </div>
        </S.Content>
    </S.CustomContainer>
  )
})